export const CREATE_CRON_LOADING = 'CREATE_CRON_LOADING';
export const CREATE_CRON_SUCCESS = 'CREATE_CRON_SUCCESS';
export const CREATE_CRON_ERROR = 'CREATE_CRON_ERROR';

export const FETCH_CRONS_LOADING = 'FETCH_CRONS_LOADING';
export const FETCH_CRONS_SUCCESS = 'FETCH_CRONS_SUCCESS';
export const FETCH_CRONS_ERROR = 'FETCH_CRONS_ERROR';

export const DELETE_CRON_LOADING = 'DELETE_CRON_LOADING';
export const DELETE_CRON_SUCCESS = 'DELETE_CRON_SUCCESS';
export const DELETE_CRON_ERROR = 'DELETE_CRON_ERROR';
